import React, { useState, useRef, useEffect } from "react";
import useRequireAuth from "../../../utils/useRequireAuth";
import { useSelector } from "react-redux";

import useDropdownPosition from "../../../hooks/Dropdown/useDropDownPosition";
import CreatePortalHOC from "../../GlobalFeature/Fields/CreatePortalHOC";
import ShareIcon from "../../../assets/images/icons/shareIcon.svg";
import z_ai_Icon from "../../../assets/images/icons/z_ai.svg";
import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";

const FolderAction = ({
  Item,
  multiData = [],
  handleMove,
  handleShare,
  handleOverview,
  handleRequestAccess,
  handleAddTask,
  documentType,
}) => {
  const { token } = useRequireAuth();
  const [isOpenHover, setIsOpenHover] = useState(false);
  const { dropdownPosition, dropdownRef } = useDropdownPosition(true, "fullscreen-table");
  const [dropdownCoord, setDropdownCoord] = useState(null);

  const popupRef = useRef(null);

  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      // closePopup();
    }
  };

  useEffect(() => {
    if (dropdownCoord !== null && !isOpenHover) {
      setIsOpenHover(true);
    }
  }, [dropdownCoord]);

  // useEffect(() => {
  //   if (tooltipCoord !== null && !isOpenTooltip) {
  //     setIsOpenHover(true);
  //   }
  // }, [tooltipCoord]);

  const getCreatePortalPosition = (ele) => {
    if (ele.current) {
      const rect = ele.current.getBoundingClientRect(); // Get the bounding rectangle
      const left = rect.left + 30;
      const top = rect.top - 15;
      return {
        top: top + window.scrollY,
        left: left + window.scrollX,
        borderRadius: "5",
      };
    }
  };

  const handleOpen = (event) => {
    event.stopPropagation();
    setDropdownCoord((prevState) => {
      return getCreatePortalPosition(dropdownRef);
    });
  };

  const handleClose = () => {
    setDropdownCoord(null);
    setIsOpenHover(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };

  const user = useSelector((store) => store.user);

  return (
    <div className={`flex gap-1 visible group-hover:visible`}>
      {Item?.display_name?.includes(".pdf") && (
        <div>
          <ToolTipComponent text={"AI Overview"}>
            <button className="p-1 hover:bg-[#F1F1F1] rounded group">
              <img
                className={`transition-transform -rotate-90 group-hover:rotate-0 w-4`}
                src={z_ai_Icon}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOverview(Item);
                  // handleClose();
                }}
              />
            </button>
          </ToolTipComponent>
        </div>
      )}
      {/* <div>
        <ToolTipComponent text={"Share"}>
          <button className="p-1 hover:bg-[#F1F1F1] rounded mt-1">
            <img
              src={ShareIcon}
              // className="w-5"
              onClick={(e) => {
                e.stopPropagation();
                handleShare(Item);
                // handleClose();
              }}
            />
          </button>
        </ToolTipComponent>
      </div> */}
      <div onMouseOver={handleOpen} onMouseLeave={handleClose}>
        <button
          type="button"
          id="threedot"
          className="threedot text-2541558A hover:text-254155 p-1 hover:bg-[#F1F1F1] rounded"
          disabled
          ref={dropdownRef}
        >
          <i className=" bi bi-three-dots text-14"></i>
        </button>
        <CreatePortalHOC isOpen={isOpenHover} onClose={handleClose} position={dropdownCoord} verticalDist={8}>
          {/* <WithPortal
          open={isOpenHover}
          onClose={handleClose}
          containerRef={dropdownRef}
          yAxis={-36}
          xAxis={30}
          showArrow
        > */}
          <div className="w-[140px]">
            <div class="arrow-left "></div>
            {multiData.length < 2 && (
              <>
                <div className="p-1 m-1 hover:bg-[#F3F5F7]">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMove(Item, "move");
                      handleClose();
                    }}
                    type="button"
                    className="text-14 text-778FA5 hover:text-1D4469"
                  >
                    <span className="">
                      {/* <NotesIcon /> */}
                      <span className="ms-2">Move To</span>
                    </span>
                  </button>
                </div>
                {/* )} */}
              </>
            )}
            <>
              <div className="p-1 m-1 cursor-not-allowed hover:bg-[#F3F5F7]">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  type="button"
                  className="text-14 cursor-not-allowed text-778FA5 hover:text-1D4469"
                >
                  <span className="">
                    {/* <GrantIcon /> */}
                    <span className="ms-2">Copy To</span>
                  </span>
                </button>
              </div>
              {/* )} */}
            </>
            <>
              {documentType === "file" && (
                <div className="p-1 m-1 cursor-not-allowed hover:bg-[#F3F5F7]">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddTask();
                    }}
                    type="button"
                    className="text-14 text-778FA5 hover:text-1D4469"
                  >
                    <span className="">
                      {/* <GrantIcon /> */}
                      <span className="ms-2">Add Task</span>
                    </span>
                  </button>
                </div>
              )}
            </>
          </div>
          {/* </WithPortal> */}
        </CreatePortalHOC>
      </div>
    </div>
  );
};

export default FolderAction;
